import React from "react";
import { Box, Text, Link, Flex, Image } from "@chakra-ui/react";
import { FaInstagram, FaFacebook, FaYoutube } from "react-icons/fa";
import { IconType } from "react-icons";
import { useTranslation } from "react-i18next";
import Section from "./Section";
import QRCodeImage from "../images/mascot-QR/QR.png";

const SocialMedia: React.FC = () => {
  const { t } = useTranslation();

  type SocialLink = {
    platform: string;
    handle: string;
    Icon?: IconType;
    url: string;
    color?: string;
    qrCode?: string;
  };

  const SocialIcon: React.FC<{
    Icon: IconType;
    boxSize?: string | number;
    color?: string;
  }> = ({ Icon, boxSize = "3rem", color }) => {
    const IconComponent = Icon as React.ComponentType<React.SVGProps<SVGSVGElement>>;
    return (
      <IconComponent
        style={{
          width: boxSize,
          height: boxSize,
          color: color,
        }}
      />
    );
  };

  const socialLinks: SocialLink[] = [
    {
      platform: "Instagram",
      handle: "@deepsoul_m_h",
      Icon: FaInstagram,
      url: "https://www.instagram.com/deepsoul_m_h/",
      color: "#E1306C",
    },
    {
      platform: "Facebook",
      handle: "@Deep Soul 深靈",
      Icon: FaFacebook,
      url: "https://www.facebook.com/profile.php?id=61557089692916",
      color: "#1877F2",
    },
    {
      platform: "YouTube",
      handle: t("socialMedia.watchVideo"),
      Icon: FaYoutube,
      url: "https://www.youtube.com/@DeepSoul-bb4mo/shorts",
      color: "#FF0000",
    },
    {
      platform: t("socialMedia.qr.title"), // 直接使用 t 函數
      handle: t("socialMedia.qr.scan"), // 直接使用 t 函數
      url: "https://deepsoulai.onelink.me/bf43/downloadAppDC",
      qrCode: QRCodeImage,
    },
  ];

  return (
    <Section title={`${t("socialMedia.title")}`} maxW="1400px" id="social-media">
      <Box py={{ base: 2, md: 3 }} px={{ base: 0, md: 2 }}>
        <Flex wrap="wrap" gap={3}>
          {socialLinks.map((social) => (
            <Link
              key={social.platform}
              href={social.url}
              isExternal
              display="inline-flex"
              alignItems="center"
              gap={3}
              minH="64px"
              px={4}
              py={3}
              flex={{ base: "1 1 100%", sm: "1 1 calc(50% - 12px)", lg: "1 1 0" }}
              borderRadius="xl"
              border="1px solid"
              borderColor="blackAlpha.100"
              bg="white"
              textDecoration="none"
              transition="transform 180ms ease, box-shadow 180ms ease"
              _hover={{
                transform: "translateY(-2px)",
                boxShadow: "md",
                textDecoration: "none",
              }}
              _focusVisible={{
                outline: "3px solid",
                outlineColor: "primary.300",
                outlineOffset: "3px",
              }}
            >
              {social.qrCode ? (
                <Image
                  src={social.qrCode}
                  alt=""
                  aria-hidden="true"
                  boxSize="44px"
                  objectFit="contain"
                />
              ) : (
                social.Icon && (
                  <SocialIcon
                    Icon={social.Icon}
                    boxSize="2rem"
                    color={social.color}
                  />
                )
              )}
              <Box minW={0}>
                <Text fontWeight="700" lineHeight="1.3">
                  {social.platform}
                </Text>
                <Text color="gray.500" fontSize="sm" noOfLines={1}>
                  {social.handle}
                </Text>
              </Box>
            </Link>
          ))}
        </Flex>
      </Box>
    </Section>
  );
};

export default SocialMedia;
